import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { formatStripeAmount } from '../advisor/utils'

const beautifyFreq = (freq) => {
  switch (freq) {
    case 'month':
      return 'Monthly'
    case 'year':
      return 'Yearly'
    default:
      return freq
  }
}

const calculateYearlySavings = (prices) => {
  const monthlyPrice = prices.find((p) => p.interval === 'month')
  const yearlyPrice = prices.find((p) => p.interval === 'year')

  if (monthlyPrice && yearlyPrice) {
    const totalMonthlyCost = monthlyPrice.amount * 12
    const savings = totalMonthlyCost - yearlyPrice.amount
    const percentageSavings = (savings / totalMonthlyCost) * 100
    return percentageSavings.toFixed(0)
  }

  return null
}

const BillingFrequencySwitch = ({
  plans,
  plan,
  price,
  setPlan,
  setPrice,
  hidePlanSelector = false
}) => {
  const [selectedPriceId, setSelectedPriceId] = useState(price?.id || plan.prices[0]?.id)
  const yearlySavings = calculateYearlySavings(plan.prices) // Calculate yearly savings dynamically

  const handlePriceChange = (priceId) => {
    setSelectedPriceId(priceId)
    const selectedPrice = plan.prices.find((p) => p.id === priceId)
    if (selectedPrice) setPrice(selectedPrice)
  }

  return (
    <div className="billing-frequency">
      {!hidePlanSelector && plans && (
        <select
          value={plans.findIndex((p) => p.id === plan.id)}
          onChange={(e) => setPlan(plans[e.target.value])}
          className="form-control billing-plan"
        >
          {plans.map((plan, index) => (
            <option key={index} value={index}>
              {plan.name}
            </option>
          ))}
        </select>
      )}
      {plan.prices.length > 0 && (
        <div className="radio-group">
          {plan.prices.map((priceOption) => (
            <div key={priceOption.id} className="radio-container">
              <label className="radio-option mt-md mb-md">
                <input
                  type="radio"
                  name="subscription_frequency"
                  value={priceOption.id}
                  checked={selectedPriceId === priceOption.id}
                  onChange={() => handlePriceChange(priceOption.id)}
                />
                <span className="ml-sm">
                  {beautifyFreq(priceOption.interval)} Subscription:{' '}
                  {formatStripeAmount(priceOption.amount)} /{' '}
                  {priceOption.interval}
                  {priceOption.interval === 'year' && yearlySavings && (
                    <span className="pl-xs">
                      <small>(Save {yearlySavings}%)</small>
                    </span>
                  )}
                </span>
              </label>
            </div>
          ))}
        </div>
      )}
      {plan.prices.length === 0 && (
        <div>No subscription options are currently available.</div>
      )}
    </div>
  )
}

BillingFrequencySwitch.propTypes = {
  plans: PropTypes.array.isRequired,
  plan: PropTypes.object.isRequired,
  price: PropTypes.object.isRequired,
  setPlan: PropTypes.func.isRequired,
  setPrice: PropTypes.func.isRequired,
  hidePlanSelector: PropTypes.bool
}

export default BillingFrequencySwitch
